window.PhotoGalleryInit = function (wrapId, lightboxId) {
  var wrap = document.getElementById(wrapId);
  var lightbox = document.getElementById(lightboxId);
  if (!wrap || !lightbox) return;

  var tabs = wrap.querySelectorAll('.pg-tab');
  var items = Array.prototype.slice.call(wrap.querySelectorAll('.pg-item'));
  var images = items.map(function (item) { return item.querySelector('.pg-img'); });

  var stage = lightbox.querySelector('.pg-lb-stage');
  var lbImg = lightbox.querySelector('.pg-lb-img');
  var lbCaption = lightbox.querySelector('.pg-lb-caption');
  var closeBtn = lightbox.querySelector('.pg-lb-close');
  var prevBtn = lightbox.querySelector('.pg-lb-prev');
  var nextBtn = lightbox.querySelector('.pg-lb-next');

  var visibleImages = images;
  var currentIndex = 0;
  var scale = 1;
  var translateX = 0;
  var translateY = 0;
  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;

  // Filtering
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var filter = tab.getAttribute('data-filter');

      items.forEach(function (item) {
        var match = filter === 'all' || item.getAttribute('data-category') === filter;
        item.classList.toggle('is-hidden', !match);
      });

      visibleImages = images.filter(function (img) {
        return !img.closest('.pg-item').classList.contains('is-hidden');
      });
    });
  });

  function resetZoom() {
    scale = 1;
    translateX = 0;
    translateY = 0;
    lbImg.style.transform = 'translate(0px, 0px) scale(1)';
    stage.classList.remove('is-zoomed');
  }

  function applyTransform() {
    lbImg.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')';
    stage.classList.toggle('is-zoomed', scale > 1);
  }

  function showImage(index) {
    if (!visibleImages.length) return;
    currentIndex = (index + visibleImages.length) % visibleImages.length;
    var img = visibleImages[currentIndex];
    lbImg.src = img.getAttribute('data-full') || img.src;
    lbImg.alt = img.alt || '';
    lbCaption.textContent = img.getAttribute('data-caption') || '';
    resetZoom();
  }

  function openLightbox(index) {
    showImage(index);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetZoom();
  }

  items.forEach(function (item, i) {
    item.addEventListener('click', function () {
      var img = item.querySelector('.pg-img');
      var indexInVisible = visibleImages.indexOf(img);
      openLightbox(indexInVisible === -1 ? 0 : indexInVisible);
    });
  });

  closeBtn.addEventListener('click', closeLightbox);
  prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });
  nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
  });

  // Double-click to zoom in/out
  stage.addEventListener('dblclick', function () {
    if (scale === 1) {
      scale = 2.2;
    } else {
      scale = 1;
      translateX = 0;
      translateY = 0;
    }
    applyTransform();
  });

  // Scroll wheel to zoom
  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    var delta = e.deltaY < 0 ? 0.15 : -0.15;
    scale = Math.min(4, Math.max(1, scale + delta));
    if (scale === 1) { translateX = 0; translateY = 0; }
    applyTransform();
  }, { passive: false });

  // Drag to pan when zoomed
  stage.addEventListener('mousedown', function (e) {
    if (scale === 1) return;
    isDragging = true;
    stage.classList.add('is-dragging');
    dragStartX = e.clientX - translateX;
    dragStartY = e.clientY - translateY;
  });

  window.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    translateX = e.clientX - dragStartX;
    translateY = e.clientY - dragStartY;
    applyTransform();
  });

  window.addEventListener('mouseup', function () {
    isDragging = false;
    stage.classList.remove('is-dragging');
  });

  // Basic touch support: pinch-free double-tap to zoom, single-finger pan when zoomed
  var lastTap = 0;
  stage.addEventListener('touchend', function (e) {
    var now = Date.now();
    if (now - lastTap < 300) {
      if (scale === 1) { scale = 2.2; } else { scale = 1; translateX = 0; translateY = 0; }
      applyTransform();
    }
    lastTap = now;
  });

  var touchStartX = 0, touchStartY = 0;
  stage.addEventListener('touchstart', function (e) {
    if (scale === 1 || e.touches.length !== 1) return;
    touchStartX = e.touches[0].clientX - translateX;
    touchStartY = e.touches[0].clientY - translateY;
  }, { passive: true });

  stage.addEventListener('touchmove', function (e) {
    if (scale === 1 || e.touches.length !== 1) return;
    translateX = e.touches[0].clientX - touchStartX;
    translateY = e.touches[0].clientY - touchStartY;
    applyTransform();
  }, { passive: true });
};
